import { render, staticRenderFns } from "./LabelEditDialog.vue?vue&type=template&id=15b1b856&"
import script from "./LabelEditDialog.vue?vue&type=script&lang=ts&"
export * from "./LabelEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports